import { EstimatRequestResponse } from '@/models/EstimateRequestResponse';
import { Site } from '@/models/Site';
import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { EstimateFormStep, EstimateRequestState } from './state';


export const getters: GetterTree<EstimateRequestState, RootState> = {
    getObjetValue(state): string {
        return state.objet;
    },
    getSiteValue(state): Site | undefined {
        return state.site;
    },
    getDescriptifValue(state): string {
        return state.descriptif;
    },
    getDateValue(state): string | undefined {
        return state.date;
    },
    getAskEstimateData(state): EstimateRequestState {
        return state;
    },
    getEstimateSendLoading(state): boolean {
        return state.isLoading;
    },
    getEstimateStepValue(state): EstimateFormStep {
        return state.step;
    },
    getEstimateRequestSuccess(state): boolean {
        return state.success;
    },
    getEstimateRequestResponse(state): EstimatRequestResponse | undefined {
        return state.response;
    },
    getEstimateFiles(state): File[] {
        return state.documents;
    },
    isEstimateFormValid(state): boolean {
        switch (state.step) {
            case EstimateFormStep.first:
                return state.site !== undefined;
            case EstimateFormStep.second:
                return state.objet !== '' && state.date !== '' && state.descriptif.length >= 50;
        }
    }
};
